import React from 'react';

function LabDirector() {
    return (
        <>
        <div style={{ display: 'flex', minHeight: '20vh', padding: '0 50px', justifyContent: 'right', whiteSpace: 'nowrap', overflow: 'hidden' }}>
            {/* Left Section */}
            <div style={{ flex: 0.9, display: 'flex', flexDirection: 'column', justifyContent: 'right', alignItems: 'flex-end', padding: '20px' }}>
                <img
                    src="BurakNewProfile.jpeg"
                    alt="Profile"
                    style={{ width: '80%', maxWidth: '250px', borderRadius: '10px', marginRight: '0px' }}
                />
            </div>


            {/* Center Section */}
            <div style={{ flex: 1.2, fontSize: '18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '10px', whiteSpace: 'nowrap' }}>
                <h2 style={{ marginBottom: '10px' }}>University of Ottawa</h2>
                <p style={{ marginBottom: '5px' }}>School of Electrical Engineering and Computer Science</p>
                <p style={{ marginBottom: '5px' }}>Ottawa, ON, K1N 6N5</p>
                <p style={{ marginBottom: '5px' }}>Phone: (613) 562-5800 ext 6955</p>
                <p>Email: <a href="mailto:burak.kantarci@uOttawa.ca" style={{ textDecoration: 'underline', color: 'darkblue' }}>burak.kantarci@uOttawa.ca</a></p>
            </div>

            {/* Right Section */}
            <div style={{ flex: 0.9, padding: '60px', fontSize: '16px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                <ul style={{ listStyleType: 'none', padding: 0, textAlign: 'left', marginLeft: '0px' }}>
                    <li style={{ marginBottom: '10px' }}>
                        <span
                            style={{
                            display: 'inline-block',
                            width: '10px',
                            height: '10px',
                            backgroundColor: 'black',
                            transform: 'rotate(45deg)',
                            marginRight: '10px',
                            }}
                        ></span>
                        <a
                            href="/CVKantarciBurak.pdf"
                            rel="noopener noreferrer"
                            target="_blank"
                            style={{ fontWeight: 'bold', color: 'green', textDecoration: 'underline' }}
                        >
                            Curriculum Vitae (in pdf)
                        </a>
                        </li>
                    {/*
                    <li style={{ marginBottom: '10px' }}>
                        <span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: 'black', transform: 'rotate(45deg)', marginRight: '10px' }}></span>
                        <a href="https://www.site.uottawa.ca/~bkantarc/CV.pdf" rel="noopener noreferrer" target="_blank" style={{ fontWeight: 'bold', color: 'green', textDecoration: 'underline' }}>Curriculum Vitae (in pdf)</a>
                    </li>
                    */}
                    <li style={{ marginBottom: '10px' }}>
                        <span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: 'black', transform: 'rotate(45deg)', marginRight: '10px' }}></span>
                        <a href="https://nextconlab.ca/" style={{ fontWeight: 'bold', color: 'green', textDecoration: 'underline' }}>SCVIC and NEXTCON Lab</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: 'black', transform: 'rotate(45deg)', marginRight: '10px' }}></span>
                        <span style={{ fontWeight: 'bold', color: 'green' }}>External</span>
                        <ul style={{ paddingLeft: '30px', listStyleType: 'circle', marginLeft: '0px' }}>
                            <li><a href="https://scholar.google.com/citations?user=NBFqTFcAAAAJ&hl=en" rel="noopener noreferrer" target="_blank" style={{ color: 'darkblue', textDecoration: 'underline' }}>Google Scholar</a></li>
                            <li><a href="https://www.linkedin.com/in/bkantarci/" rel="noopener noreferrer" target="_blank" style={{ color: 'darkblue', textDecoration: 'underline' }}>LinkedIn</a></li>
                            <li><a href="https://www.researchgate.net/profile/Burak-Kantarci" rel="noopener noreferrer" target="_blank" style={{ color: 'darkblue', textDecoration: 'underline' }}>ResearchGate</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>



            {/* Additional Paragraph at the Bottom */}
            <div style={{fontSize: '18px', display: 'flex', minHeight: '20vh', marginLeft:'12%',marginRight:'12%', justifyContent: 'right', overflow: 'hidden' }}>
                <p align="justify">
                    In <span style={{ fontWeight: 'bold' }}>SCVIC and NEXTCON Lab</span>, my team and I are committed to creating an environment that is clearly 
                    supportive, diverse, gender-balanced, collegial and open to the researchers with strongest technical 
                    skills regardless of their background. I am looking for enthusiastic PhD students and 
                    Postdoctoral Fellows who will work on the topics listed below (see: current research interests below). 
                    Interested students or postdoc applicants may contact me via <a href="mailto:scvic-civic@uottawa.ca" style={{ fontWeight: 'bold', color: 'darkblue', textDecoration: 'underline' }}>scvic-civic@uottawa.ca</a> to inquire the possibility 
                    of joining my team.
                </p>
            </div>


        </>
    );
}

export default LabDirector;